import { jsx as _jsx } from "react/jsx-runtime";
import React, { useImperativeHandle } from 'react';
import { Form } from "antd";
import VehicleSelect from "./VehicleSelect";
const FleetVehicleForm = ({ tenantId, onVehicleSelected, allowClear = true }, exportedRef) => {
    const [form] = Form.useForm();
    useImperativeHandle(exportedRef, () => ({
        resetFields: () => {
            form.resetFields();
        },
        validateFields: () => {
            return form.validateFields();
        }
    }));
    return (_jsx(Form, { form: form, children: _jsx(Form.Item, { name: "vehicleId", label: "Vehicle", rules: [{
                    required: true,
                    message: 'A vehicle is required.',
                }], children: _jsx(VehicleSelect, { tenantId: tenantId, onVehicleSelected: onVehicleSelected, allowClear: allowClear }) }) }));
};
export default React.forwardRef(FleetVehicleForm);
